import { notificationsApi } from '../api/notifications';
import { subscribeRealtime } from './realtime';

export const NOTIFICATION_COUNTS_CHANGED = 'amposter:notification-counts-changed';
const subscriptions = new Map();
const events = new Set(['ready', 'resync', 'notification.changed', 'access.changed', 'report.reply.created', 'report.replies.read', 'profile-media.queue.changed']);

// The navigation and menu share one request and one WebSocket subscription.
// Account-scoped, memory-only; never persist private notification counts.
export function watchNotificationCounts(userId, callback) {
  if (!userId) { callback({ total: 0, menuCounts: {} }); return () => {}; }
  let entry = subscriptions.get(userId);
  if (!entry) {
    entry = { listeners: new Set(), value: null, active: true, pending: null, dirty: false };
    subscriptions.set(userId, entry);
    const refresh = async () => {
      if (entry.pending) { entry.dirty = true; return entry.pending; }
      entry.pending = notificationsApi.unreadCount().then(value => {
        if (!entry.active) return;
        entry.value = value;
        entry.listeners.forEach(listener => listener(value));
      }).catch(() => {}).finally(() => {
        entry.pending = null;
        if (entry.active && entry.dirty) { entry.dirty = false; void refresh(); }
      });
      return entry.pending;
    };
    let timer;
    const changed = () => { clearTimeout(timer); timer = setTimeout(refresh, 100); };
    const stop = subscribeRealtime(event => { if (events.has(event.type)) changed(); });
    window.addEventListener(NOTIFICATION_COUNTS_CHANGED, changed);
    entry.stop = () => { entry.active = false; clearTimeout(timer); stop(); window.removeEventListener(NOTIFICATION_COUNTS_CHANGED, changed); };
    void refresh();
  }
  entry.listeners.add(callback);
  if (entry.value) callback(entry.value);
  return () => {
    entry.listeners.delete(callback);
    if (!entry.listeners.size) { entry.stop(); subscriptions.delete(userId); }
  };
}
